import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { API_URL } from "../../../actions/settings";
import LoadingSpinner from "../../extras/LoadingSpinner";
import { formatGraphData, isStaff } from "../../extras/Functions";
import { useAppSelector } from "../../../Hooks";
import { selectUser } from "../../../reducers/UserReducer";


interface Props {
  id: string;
}

const formatValue = (value:number)=> {
    const formatter = new Intl.NumberFormat('en-US',{notation:'compact',maximumFractionDigits: 1 })
    return formatter.format(value)
  }


async function getElectricityUse(token: string, id: string) {
  return fetch(`${API_URL}/graphs/electricity_use_trends/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      return false;
    }});
}

const CustomTooltip = ({ active, payload, label, dataKey }:any)=>{
    return <div style={{background:'white',border:'black solid 2px', padding:'5px'}}>
          {payload.map((entry:any, index:any) => (<div key={index}>
            <div style={{color:'black'}} >
              {entry.name}: {formatValue(entry.value)}
            </div>
            </div>
          ))}
    </div>
  }

const CustomTick = ({x,y,payload}:any)=>{
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';
    return <g transform={`translate(${x},${y})`}>
    <text x={0} y={0} dy={16} textAnchor="end" fill={newUI?"black":"white"} transform="rotate(-35)">
      {payload.value}
    </text>
  </g>
}

const ElectricityUseGraph: React.FC<Props> = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const user = useAppSelector(selectUser);
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

  useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const res = await getElectricityUse(token, id);
      if(res) {setData(formatGraphData(res.data))} else setData(null)
      setLoading(false);
    };

    handleData();
  }, [id]);
  return (
    <div>
      {loading ? (
        <LoadingSpinner />
      ) : !data ? (
        <div style={{height:'300px'}} className="center-all">
          <div style={{ width: "100%", textAlign: "center", fontSize: "larger" }}>
            No Score Data Available
          </div>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={450}>
        <LineChart
          width={500}
          height={400}
          data={data}
          margin={{
            top: 5,
            right: 0,
            left: 15,
            bottom: 30,
          }}
        >
          <CartesianGrid strokeDasharray="10 10" />
          <XAxis tick={CustomTick}axisLine={false} dataKey="months" />
          <YAxis tickFormatter={formatValue} tick={{fill:newUI?'black':'white'}} axisLine={false} label={{ value: 'kWh', angle: -90, position: 'insideLeft' }}/>
          <Tooltip content={CustomTooltip}/>
          <Legend />
          {isStaff(user) ? 
          <Line type="monotone" dataKey="baseline" name="Baseline" strokeWidth={1} stroke="#817ac7ff" /> : null }
          <Line type="monotone" dataKey="adjusted" name={ isStaff(user) ? "Adjusted Baseline":"Baseline"} strokeWidth={3} stroke="#FFA500" />
          <Line type="monotone" dataKey="actual" name="Current" strokeWidth={3} stroke="#01e8ff" />    
          <Line type="monotone" dataKey="model" name="Model" strokeWidth={3} stroke="#FF007F" />
          
        </LineChart>
       </ResponsiveContainer>
      )}
    </div>
  );
};

export default ElectricityUseGraph;
